"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Positionable_1 = require("./Positionable");
var TransformBox_1 = require("./TransformBox");
exports.PositionableContainer = function (_a) {
    var children = _a.children, disabled = _a.disabled, disableKeyboardMovement = _a.disableKeyboardMovement, _b = _a.Element, Element = _b === void 0 ? 'div' : _b, group = _a.group, movable = _a.movable, onClick = _a.onClick, onUpdate = _a.onUpdate, position = _a.position, render = _a.render, resizable = _a.resizable, rotatable = _a.rotatable, snapTo = _a.snapTo, snapXTo = _a.snapXTo, snapYTo = _a.snapYTo, style = _a.style, rest = __rest(_a, ["children", "disabled", "disableKeyboardMovement", "Element", "group", "movable", "onClick", "onUpdate", "position", "render", "resizable", "rotatable", "snapTo", "snapXTo", "snapYTo", "style"]);
    return (React.createElement(Positionable_1.Positionable, { disabled: disabled, disableKeyboardMovement: disableKeyboardMovement, group: group, movable: movable, onClick: onClick, onUpdate: onUpdate, position: position, resizable: !!resizable, rotatable: rotatable, snapTo: snapTo, snapXTo: snapXTo, snapYTo: snapYTo, render: function (_a) {
            var renderedPosition = _a.renderedPosition, refHandlers = _a.refHandlers;
            return (React.createElement(React.Fragment, null,
                React.createElement(Element, __assign({ ref: refHandlers.container, style: __assign(__assign({}, style), { height: "" + renderedPosition.height, left: "" + renderedPosition.left, position: 'absolute', top: "" + renderedPosition.top, transform: "rotate(" + renderedPosition.rotation + ")", width: "" + renderedPosition.width }) }, rest), render ? render() : children),
                !disabled && (resizable || rotatable || movable) && (React.createElement(TransformBox_1.default, { position: renderedPosition, refHandlers: refHandlers, resizable: resizable, rotatable: rotatable }))));
        } }));
};
exports.default = exports.PositionableContainer;
//# sourceMappingURL=PositionableContainer.js.map